export enum RouteParam {
  Id = ":id",
}

export type MappedObject<K extends string, V> = { [key in K]?: V };
export type RouteParams = MappedObject<RouteParam, string>

export type RouteParamValues<T> = { [key in keyof T]?: RouteParam };

export interface RouteParamReplaceAction {
  param: RouteParam,
  value: string
}

export type IDynamicRoute = {
  route: string,
  getValue: (values: RouteParams) => string,
  query: (values?: Record<string, any>) => string
}

const getRoute = (...parts: string[]): IDynamicRoute => {

  const getValue = () => {
    if (!parts?.length) return "/";
    return `/${parts.join("/")}`;
  }

  const routeValue = getValue();

  return {
    route: routeValue,
    getValue: (values: RouteParams) => {
      if (!values) return routeValue;

      let r = routeValue;

      for (const [key, value] of Object.entries(values)) {
        r = r.replace(key, value);
      }
      return r;
    },
    query: (values?: Record<string, any>) => {

      if (!values) return routeValue;

      let parts = [];

      for (const [key, value] of Object.entries(values)) {
        if (value === undefined || value === null) continue;
        parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
      }

      const queryString = parts.join("&");
      return `${routeValue}?${queryString}`;
    }
  };
}

export const ROUTES = {
  Auth: {
    Login: "/auth/login",
    Verify: "/auth/verify",
    Session: "/auth/session",
    Logout: "/auth/logout",
  },
  Services: {
    GHL: {
      Tags: {
        All: "/services/ghl/tags",
      }
    }
  },
  Ai: getRoute("ai"),
  AiTools: {
    WebSearch: "/ai/tools/web-search",
    ContainerFileDownload: getRoute("ai/tools/container-files", RouteParam.Id)
  },
  ChatHistory: getRoute("ai", "history"),
  ChatHistoryExport: getRoute("ai", "history", "export"),
  ChatHistoryById: getRoute("ai", "history", RouteParam.Id),
  Usage: "/ai/usage",
  Models: {
    All: getRoute("ai", "models"),
    ById: getRoute("ai", "models", RouteParam.Id),
    External: "/ai/models/external",
  },
  ModelPrices: {
    All: getRoute("ai", "model-prices"),
    ById: getRoute("ai", "model-prices", RouteParam.Id),
  },
  Settings: "/settings",
  Skills: {
    ById: getRoute("ai", "skills", RouteParam.Id),
    All: getRoute("ai", "skills"),
    External: "/ai/skills/external",
  },
  Products: {
    All: "/products",
    ById: getRoute("products", RouteParam.Id),
  },
  Files: {
    All: "/files",
    Tools: "/files/tools",
    ById: getRoute("files", RouteParam.Id)
  },
  Links: {
    Favorites: {
      All: "/links/favorites",
      ById: getRoute("links/favorites", RouteParam.Id)
    },
    All: "/links",
    Bulk: "/links/bulk",
    ById: getRoute("links", RouteParam.Id)
  },
  Deals: {
    All: "/",
    ById: getRoute("deals", RouteParam.Id)
  }
}